import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

import Table from '../common/table';
import OrderGuideRow from '../order-guide/orderguide-row';
import { filterItemsV2, isValidInteger } from '../../common/utils/generalFunctions';

const getHeaders = () => {
  return [
    { header: 'Order', className: 'setWidth90', name: 'order', disableSort: true },
    { header: 'Info', className: 'setWidth50', name: 'info', disableSort: true },
    { header: 'Item', className: 'setWidth120', name: 'itemNumber' },
    { header: 'Description', className: 'width400', name: 'description' },
    { header: 'Unit', className: 'table-cell-center setWidth120', name: 'unit' },
    { header: 'Pack', className: 'table-cell-center setWidth160', name: 'packSize' },
    { header: 'Price', className: 'table-cell-center isCurrency setWidth80', name: 'price' },
    { header: 'Par', className: 'table-cell-center setWidth160', name: 'par' }
  ];
};

const getItemKey = (item) => {
  if (!item) {
    return '';
  }

  if (item.masterRecordId) {
    return `m-${item.masterRecordId}`;
  }

  if (item.itemNumber) {
    return `i-${item.itemNumber}`;
  }

  return '';
};

const mapDraftItemsByKey = (draftItems) => {
  const result = {};

  (draftItems || []).forEach(item => {
    const key = getItemKey(item);
    if (key) {
      result[key] = item;
    }
  });

  return result;
};

export class AddRemoveItemsModal extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    orderGuideItems: PropTypes.array,
    currentDraftItems: PropTypes.array,
    selectedOrderGuide: PropTypes.object,
    closeButtonHandler: PropTypes.func.isRequired,
    previewButtonHandler: PropTypes.func.isRequired
  };

  state = {
    filterText: '',
    orderGuideItems: [],
    filteredItems: []
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const shouldRebuild =
      nextProps.show !== this.props.show
      || nextProps.orderGuideItems !== this.props.orderGuideItems
      || nextProps.currentDraftItems !== this.props.currentDraftItems;

    if (!shouldRebuild) {
      return;
    }

    const mergedItems = this.buildMergedItems(nextProps.orderGuideItems, nextProps.currentDraftItems);
    this.setState({
      filterText: '',
      orderGuideItems: mergedItems,
      filteredItems: mergedItems
    });
  }

  buildMergedItems = (orderGuideItems, currentDraftItems) => {
    const draftItemsByKey = mapDraftItemsByKey(currentDraftItems);

    return (orderGuideItems || []).map((item, index) => {
      const key = getItemKey(item);
      const matchingDraftItem = key ? draftItemsByKey[key] : null;
      const existingOrderValue = matchingDraftItem && matchingDraftItem.order !== null && matchingDraftItem.order !== undefined
        ? matchingDraftItem.order.toString()
        : '';

      return {
        ...item,
        rowIndex: index,
        order: existingOrderValue,
        pack: item.pack || item.packSize,
        packSize: item.packSize || item.pack,
        lineNote: matchingDraftItem && matchingDraftItem.lineNote ? matchingDraftItem.lineNote : ''
      };
    });
  };

  updateOrderQuantity = (event, item) => {
    const value = event.target.value;

    if (!isValidInteger(value)) {
      return;
    }

    const items = this.state.orderGuideItems.map((existingItem) => {
      if (getItemKey(existingItem) === getItemKey(item)) {
        return {
          ...existingItem,
          order: value
        };
      }

      return existingItem;
    });

    const filterText = this.state.filterText.toLowerCase().trim();
    const filteredItems = filterText
      ? filterItemsV2(items, filterText)
      : items;

    this.setState({
      orderGuideItems: items,
      filteredItems
    });
  };

  filter = (event) => {
    const inputValue = event.target.value.toLowerCase().trim();
    const { orderGuideItems } = this.state;

    if (inputValue === '') {
      this.setState({
        filterText: event.target.value,
        filteredItems: orderGuideItems
      });
      return;
    }

    const matchedItems = filterItemsV2(orderGuideItems, inputValue);

    this.setState({
      filterText: event.target.value,
      filteredItems: matchedItems
    });
  };

  handlePreviewOrder = () => {
    this.props.previewButtonHandler(this.state.orderGuideItems);
  };

  render() {
    const { closeButtonHandler, selectedOrderGuide } = this.props;
    const { filterText, filteredItems } = this.state;
    const guideName = selectedOrderGuide && selectedOrderGuide.guideName ? selectedOrderGuide.guideName : 'Selected Order Guide';

    return (
      <Modal show={this.props.show} id="addRemoveItemsModal" bsSize="large" dialogClassName="add-remove-items-modal">
        <Modal.Header>
          <Modal.Title>
            <div className="col-md-5">Add/Remove Items - {guideName}</div>
            <div className="col-md-5">
              <input
                type="text"
                value={filterText}
                onChange={this.filter}
                id="addRemoveItemsFilter"
                className="form-control filter-textbox"
                placeholder="Enter text to search..." />
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table
            id="tblAddRemoveItems"
            headers={getHeaders()}
            items={filteredItems}
            pageSize={0}
            RowComponent={OrderGuideRow}
            callback={this.updateOrderQuantity}
            wrapperClassName="tableWrapper"
            tableClassName="fixed_header" />
        </Modal.Body>
        <Modal.Footer>
          <div className="pull-right">
            <button id="btnPreviewOrderFromAddRemove" className="btn btn-primary btn-sm" style={{ marginLeft: '8px' }} onClick={this.handlePreviewOrder}>Preview Changes</button>
          </div>  
          <div className="pull-right">
            <button className="btn btn-default btn-sm" onClick={closeButtonHandler}>Discard Changes</button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default AddRemoveItemsModal;
